import { z } from 'zod';

import { text, type Cell, type Parsed } from './cells';

// Celdas de personas de la plantilla (Dueño y columnas de rol): correos validados igual
// que en el servidor (z.email) y códigos de puesto, con mensajes que orientan.

const EMAIL = z.string().max(254).pipe(z.email());
const isEmail = (s: string): boolean => EMAIL.safeParse(s).success;

export function email(cell: Cell): Parsed<string> {
  const s = text(cell);
  if (s === undefined) {
    return { ok: undefined };
  }
  return isEmail(s) ? { ok: s } : { error: 'Correo no válido.' };
}

/** Un responsable de la celda: correo de persona o código de puesto (sin espacios). */
function personOrPosition(token: string): Parsed<{ email: string } | { positionCode: string }> {
  if (token.includes(',')) {
    return { error: 'Separa las personas y los puestos con punto y coma (;).' };
  }
  if (token.includes('@')) {
    return isEmail(token)
      ? { ok: { email: token } }
      : { error: `"${token}" no es un correo válido.` };
  }
  if (/\s/.test(token)) {
    return {
      error: `"${token}" no es un correo ni un código de puesto. Escribe el correo de la persona o el código del puesto.`,
    };
  }
  return token.length > 50
    ? { error: 'Cada código de puesto admite hasta 50 caracteres.' }
    : { ok: { positionCode: token } };
}

/** Personas (correo) o puestos (código) separados por punto y coma o salto de línea. */
export function people(cell: Cell): Parsed<({ email: string } | { positionCode: string })[]> {
  const s = text(cell);
  if (s === undefined) {
    return { ok: undefined };
  }
  const out: ({ email: string } | { positionCode: string })[] = [];
  for (const token of s
    .split(/[;\n]/)
    .map((p) => p.trim())
    .filter((p) => p !== '')) {
    const parsed = personOrPosition(token);
    if ('error' in parsed) {
      return parsed;
    }
    if (parsed.ok !== undefined) {
      out.push(parsed.ok);
    }
  }
  return { ok: out };
}
